<template>
	<span v-if="readonly && readonlyShowText" class="readonly-text">{{ value }}</span>
	<DatePicker v-else :class="style" :type="dateType" :readonly="readonly" :disabled="disabled"
		v-model="date" :format="dateFormat" :placeholder="placeholder" :transfer="true" :options="options" :editable="false">
  </DatePicker>
</template>

<script>
/**
 * ab日期控件，用法基本跟date-picker一样
 * <ab-date type="date" v-model="data.kjcs.rqkj" placeholder="Select date" style="width: 200px"></ab-date>
 */
export default {
	props: ['value',"format","type","placeholder","abPermission","min","max","minformat","maxformat","cal","caltype","readonlyShowText","disabled"],
  	data :function () {
	    return {
	    	date:null,
	    	dateType:"date",
	    	dateFormat:"",
	    	readonly : false,
	    	style : "",
	    	options: {}
	    }
	},
 	mounted : function(){
 		if(this.format){
 			this.dateFormat = this.format;
 		}else if(this.type=="date"){
 			this.dateFormat = "yyyy-MM-dd";
 		}else if(this.type=="datetime"){
 			this.dateFormat = "yyyy-MM-dd HH:mm:ss";
 		}

 		if(this.type){
 			this.dateType = this.type;
 		}else if(this.dateFormat.indexOf("HH:mm:ss")!=-1){
 			this.dateType = "datetime";
 		}else {
 			this.dateType = "date";
 		}

 		if(this.value){
 			this.date = this.value.toDate(this.dateFormat);
		}

 		this.handlePermission();
 		this.handleMinMax();//解决范围是固定值问题
 	},
	methods: {
    	handlePermission : function(){
    		if(!this.$vnode.context.$validity){
   				this.$vnode.context.$validity = {};
   			}
   			if(this.abPermission == "b"){
  			  	if(!this.value){
  				  	this.$vnode.context.$validity[this.$attrs.desc] = "必填";
  				  	this.style = "ivu-form-item-error";
  			  	}else{
  				  	delete this.$vnode.context.$validity[this.$attrs.desc];
  				  	this.style = "";
  			  	}
  		  	}
  		  // 动态权限后切换权限
  		  else if(this.$vnode.context.$validity[this.$attrs.desc]){
		  		delete this.$vnode.context.$validity[this.$attrs.desc];
		  		this.style = "";
		  }

   			if(this.disabled){
    			this.readonly = true;
    			return;
    		}

   			if(this.abPermission == "r"){
   				this.readonly = true;
   			}else{
   				// 兼容动态权限
   				this.readonly = false;
   			}
    	},
    	handleMinMax : function(){
    		this.options.disabledDate = (date) => {
				let min = new Date("1900");
				let max = new Date("9999");
				if(this.min){
					min = this.min.toDate(this.minformat);
				}
				if(this.max){
					max = this.max.toDate(this.maxformat);
				}
    			return date < min || date > max;
    		};
    	},
    	//计算差距 拿最小值跟自身比较
    	handleCal(){
    		if(!this.min||!this.value){
    			this.$emit('update:cal',"");
    			return;
    		}
    		var rtl = this.min.toDate(this.minformat).between(this.value.toDate(this.format),this.caltype);
    		this.$emit('update:cal',rtl);
    	}
  	},
 	watch : {
 		date : function(){
 			if(!this.date){
 				this.$emit('input', null);
 			}else{
 				this.$emit('input', this.date.format(this.dateFormat));
 			}
 		},
 		value : function(){
 			this.handlePermission();
 			this.handleCal();
			this.date = this.value;
 		},
 		abPermission: function(){
 			this.handlePermission();
 		},
 		min : function(newVal,oldVal){
 			this.handleCal();
			this.handleMinMax();
 		},
 		max : function(newVal,oldVal){
 			this.handleMinMax();
 		}
 	}
}
</script>
